import { render, staticRenderFns } from "./IbanPreviewPopup.vue?vue&type=template&id=231fb09d&"
import script from "./IbanPreviewPopup.vue?vue&type=script&lang=js&"
export * from "./IbanPreviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports